// extracted by mini-css-extract-plugin
export default {"linhaDado":"styles_linhaDado__RliIA"};